import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';

import { IGTFormat } from '../../context-discovery-services/models/igtformat.model';
import { ContextDiscoveryEventBusService, EBIService, SiteService } from '../../context-discovery-services/services';
import { Equipment, Message } from '../../context-discovery-services/models';
import { SeverityType } from '../../context-discovery-services/constants/severity-type.const';
import { AggregatorUtil } from '../../context-discovery-services/util';

@Component({
  selector: 'adminapp-summary-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit, AfterViewInit {

  private _modelId: any;
  private _isAssetIdentificationRequired: boolean;
  private _isModelPresent: boolean;
  getEquipmentInProgress: boolean;
  getControllerListInProgress: boolean;
  getBnaListInProgress: boolean;
  equipmentList: Equipment[];
  controllerList: Array<IGTFormat>;
  bnaList: Array<IGTFormat>;
  summaryNavBarElement: any;
  lastActiveTabId: String;
  coretexNavTabs: any = [];
  _isUnifiedFlowEnabled: boolean;

  @Input()
  set isUnifiedFlowEnabled(unifiedFlowEnabled: boolean) {
    if (this._isUnifiedFlowEnabled !== unifiedFlowEnabled) {
      this._isUnifiedFlowEnabled = unifiedFlowEnabled;
    }
  }

  @Input()
  set modelId(idOfModel: string) {
    if (this._modelId === idOfModel) {
      return;
    }
    this._modelId = idOfModel;
    if (this._modelId) {
      this.initialize();
    }
  }

  @Input()
  set isAssetIdentificationRequired(assetIdentificationRequired: boolean) {
    this._isAssetIdentificationRequired = assetIdentificationRequired;
  }

  @Input()
  set isModelPresent(modelPresent: boolean) {
    this._isModelPresent = modelPresent;
    this.initializeAssets();
  }

  @Output()
  appSideNavSelectionEventEmitter: EventEmitter<string> = new EventEmitter<string>();

  @Output()
  viewAssetsEventEmitter = new EventEmitter<void>();

  constructor(private siteService: SiteService, private ebiService: EBIService,
    private eventBusService: ContextDiscoveryEventBusService, private aggregatorUtil: AggregatorUtil) {
    this.eventBusService.serverMessage$.subscribe((message: Message) => {
      const summaryToast: any = document.getElementById(message.severityType + 'SummaryPopup');
      summaryToast.text = message.content;
      summaryToast.open();
    });
  }

  ngOnInit() {
    this.summaryNavBarElement = document.getElementById('summaryNavBar');
    if (this.summaryNavBarElement) {
      this.summaryNavBarElement.data = this.getTabs();
    }
  }

  ngAfterViewInit() {
    setTimeout(function () {
      if (this.summaryNavBarElement && this.summaryNavBarElement.shadowRoot) {
        this.coretexNavTabs = this.summaryNavBarElement.shadowRoot.querySelectorAll('coretex-nav-tab');
        this.makeTabActiveByDataId(this.coretexNavTabs[0].data.id);
      }
    }.bind(this));
  }

  initializeAssets() {
    this.getEquipmentInProgress = true;
    if (this._isModelPresent && !this._isAssetIdentificationRequired) {
      this.siteService.listEquipments(this._modelId).subscribe(this.getEquipmentSuccessCallBack.bind(this),
        this.getEquipmentFailureCallback.bind(this));
    } else {
      this.getEquipmentSuccessCallBack([]);
    }
  }

  initialize() {
    this.getControllerListInProgress = true;
    this.getBnaListInProgress = true;
    this.initializeAssets();
    this.ebiService.getFileData('controller').subscribe(this.getControllerListSuccessCallBack.bind(this),
      this.getControllerListFailureCallback.bind(this));
    this.ebiService.getFileData('bna').subscribe(this.getBnaListSuccessCallback.bind(this),
      this.getBnaListFailureCallback.bind(this));
  }

  getEquipmentSuccessCallBack(equipment: Array<Equipment>) {
    this.getEquipmentInProgress = false;
    this.equipmentList = equipment.filter((equip) => equip.confirmedAssetCount > 0);
    this.updateTab('assets', !this.equipmentList || this.equipmentList.length === 0);
  }

  getEquipmentFailureCallback() {
    this.getEquipmentInProgress = false;
    this.updateTab('assets', true);
    this.handleFailure('Something went wrong. Please try again.');
  }

  getControllerListSuccessCallBack(controllerList: Array<IGTFormat>) {
    this.getControllerListInProgress = false;
    this.updateTab('controllers', !controllerList || controllerList.length === 0);
    this.controllerList = this.aggregatorUtil.aggregate(controllerList);
  }

  getControllerListFailureCallback(error) {
    this.getControllerListInProgress = false;
    this.updateTab('controllers', true);
    console.log('Failed to get controller list');
    if (error.status !== 500 && error.status !== 404) {
      this.handleFailure('Something went wrong. Please try again.');
    }
  }

  getBnaListSuccessCallback(bnaList: Array<IGTFormat>) {
    this.getBnaListInProgress = false;
    this.updateTab('bnas', !bnaList || bnaList.length === 0);
    this.bnaList = this.aggregatorUtil.aggregate(bnaList);
  }

  getBnaListFailureCallback(error) {
    this.getBnaListInProgress = false;
    this.updateTab('bnas', true);
    console.log('Failed to get BNA list');
    if (error.status !== 500 && error.status !== 404) {
      this.handleFailure('Something went wrong. Please try again.');
    }
  }

  handleFailure(message) {
    this.eventBusService.sendMessage(new Message(message, SeverityType.CRITICAL));
  }

  makeTabActiveByDataId(tabDataId) {

    if (this.summaryNavBarElement) {
      this.summaryNavBarElement.data = this.summaryNavBarElement.data.map((item) => {
        item.active = (item.id === tabDataId);
        this.lastActiveTabId = tabDataId;
        return Object.assign({}, item);
      });
    }

    _.each(this.coretexNavTabs, function (tab) {
      tab.style.textTransform = 'capitalize';
      tab.style.marginBottom = '3px';
      tab.style.backgroundColor = 'var(--hue-white)';
      tab.style.cursor = 'pointer';
      tab.shadowRoot.querySelector('a').style.width = '100%';
      const tabIcon = tab.shadowRoot.querySelector('coretex-icon');
      if (tabIcon) {
        if (tab.data.id !== 'assets' && tab.data.id !== 'controllers' && tab.data.id !== 'bnas') {
          tabIcon.style.display = 'none';
        }
        tabIcon.style.margin = '0 10px 0 auto';
        tabIcon.style.order = 2;
      }
    });
  }

  handleRoutingRequest(event: CustomEvent) {
    this.makeTabActiveByDataId(event.detail.tab.data.id);
    this.appSideNavSelectionEventEmitter.emit('summary');
  }

  onGoToViewAssets() {
    if (this.viewAssetsEventEmitter) {
      this.viewAssetsEventEmitter.emit();
    }
  }

  updateTab(tabId, showIcon) {
    if (this.summaryNavBarElement) {
      this.summaryNavBarElement.data = this.summaryNavBarElement.data.map((item) => {
        if (item.id === tabId) {
          item.icon = showIcon ? 'hue-icons:badge-warning' : undefined;
          return Object.assign({}, item);
        }
        return item;
      });
    }
  }

  getTabs() {
    return [
      {
        id: 'assets', label: 'Assets'
      },
      {
        id: 'controllers', label: 'Controllers'
      },
      {
        id: 'bnas', label: 'BNAs'
      },
      {
        id: 'graphic-abstract', label: 'Graphic Abstract Folder'
      },
      {
        id: 'functional-description', label: 'Functional Description'
      },
      {
        id: 'metering-hierarchy', label: 'Metering Hierarchy'
      },
      {
        id: 'qb-file', label: 'QB File'
      },
      {
        id: 'anti-virus-version-report', label: 'Anti Virus Version Report'
      },
      {
        id: 'firewall-connections-status-report', label: 'Firewall/Connections Status Report'
      },
      {
        id: 'ews-health-check-report', label: 'EWS Health Check Report'
      }
    ];
  }

  retainNavSelection() {
    if (this.summaryNavBarElement) {
      this.summaryNavBarElement.data = this.summaryNavBarElement.data.map((item) => {
        if (this.lastActiveTabId === item.id) {
          item.active = true;
          return Object.assign({}, item);
        }
        return item;
      });
    }
  }
}
